import { Picker } from "antd-mobile"
import {
  CloseButton,
  PickerHeader,
  PickerPopupStyle,
  StyledInput,
  StyledLabel,
  StyledTextFieldFormItem,
} from "./styled"
import React, { useEffect, useState } from "react"
import { LogMealType } from "model/food/types/base.types"
import { capitalizeFirstLetter } from "utils/formater"

interface IProps {
  value?: LogMealType
  onChange: (value?: LogMealType) => void
  disabled?: boolean
}

const columns = ["BREAKFAST", "LUNCH", "DINNER", "SNACK"].map((item) => ({
  label: capitalizeFirstLetter(item.toLocaleLowerCase()),
  value: item,
}))

const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.06694 5.18306C5.82286 4.93898 5.42714 4.93898 5.18306 5.18306C4.93898 5.42714 4.93898 5.82286 5.18306 6.06694L9.11612 10L5.18306 13.9331C4.93898 14.1771 4.93898 14.5729 5.18306 14.8169C5.42714 15.061 5.82286 15.061 6.06694 14.8169L10 10.8839L13.9331 14.8169C14.1771 15.061 14.5729 15.061 14.8169 14.8169C15.061 14.5729 15.061 14.1771 14.8169 13.9331L10.8839 10L14.8169 6.06694C15.061 5.82286 15.061 5.42714 14.8169 5.18306C14.5729 4.93898 14.1771 4.93898 13.9331 5.18306L10 9.11612L6.06694 5.18306Z"
      fill="#69757D"
    />
  </svg>
)

const MealTypeWheelPickerFormItem = (props: IProps) => {
  const { disabled = false, value, onChange } = props
  const [pickerVisible, setPickerVisible] = useState(false)

  const [localValue, setLocalValue] = useState(value)

  useEffect(() => {
    if (value !== localValue) {
      setLocalValue(value)
    }
  }, [value])

  const displayValue = value ? capitalizeFirstLetter(value.toLowerCase()) : ""

  return (
    <StyledTextFieldFormItem>
      <StyledLabel>Meal</StyledLabel>
      <StyledInput
        style={
          {
            "--close-button-width": value ? "20px" : '0px',
            '--close-button-margin-left': value ? '4px' : '0px',
          } as React.CSSProperties
        }
        placeholder="Meal type"
        readOnly
        onFocus={() => {
          if (!disabled) setPickerVisible(true)
        }}
        $isError={false}
        value={displayValue}
        autoComplete="new-password"
      />
      {value && (
        <CloseButton
          onClick={() => {
            onChange(undefined)
            setLocalValue(undefined)
          }}
        >
          <CloseIcon />
        </CloseButton>
      )}

      <PickerPopupStyle />
      <Picker
        cancelText=""
        confirmText="Done"
        popupClassName="picker-popup"
        title={<PickerHeader />}
        visible={pickerVisible}
        onClose={() => {
          setPickerVisible(false)
        }}
        columns={[columns]}
        onConfirm={(value) => {
          onChange(value[0] as LogMealType)
        }}
        value={[localValue ?? ""]}
        onSelect={(value) => {
          setLocalValue(value[0] as LogMealType)
        }}
      />
    </StyledTextFieldFormItem>
  )
}

export default MealTypeWheelPickerFormItem
